import { Facet } from '~model/search/facets';
import { SearchResponse } from '~model/search/search';
import { Sorting } from '~model/search/sorting';
import { SuggestResponseItem } from '~model/search/suggest-response-item';
import { get } from '~service/ajax-service';
import state from '~store/search-store';
import { HistoryService } from './history-service';

class SearchServiceClass {
  globalSuggest(suggest: string): Promise<SuggestResponseItem[]> {
    // fallback for ie11
    if (!!window.navigator.userAgent.match(/MSIE|Trident/)) {
      state.suggestUrl = window.TYPO3.settings.search.suggestUrl;
    }
    return get(`${state.suggestUrl}&tx_solr[q]=${suggest}`) as Promise<SuggestResponseItem[]>;
  }

  suggest(suggest: string): Promise<SuggestResponseItem[]> {
    return get(`${window.location.pathname}?type=1471261352&tx_solr[q]=${suggest}`) as Promise<SuggestResponseItem[]>;
  }

  search(q: string) {
    HistoryService.addArgumentToUrl(window.location.href, { 'tx_solr[q]': q });
  }

  async fetch(url: string, useCache = true): Promise<SearchResponse | SuggestResponseItem[] | null> {
    let response = (await get(url, useCache)) as SearchResponse;

    if (response.result && response.result.items) {
      state.result = response.result;
    }
    if (response.facets && response.facetsDataValid) {
      state.facet = <Facet[]>Object.keys(response.facets).map(key => response.facets[key]);
    }
    if (response.sortings) {
      state.sorting = <Sorting[]>Object.keys(response.sortings).map(key => response.sortings[key]);
    }
    if (response.search) {
      state.link = response.search.links;
    }

    return response;
  }

  async loadNext(url: string) {
    try {
      const { result, search } = (await get(url)) as SearchResponse;

      if (result && result.items) {
        state.result = Object.assign({}, state.result, { items: [...state.result.items, ...result.items] });
      }
      if (search) {
        state.link = search.links;
      }
    } catch (e) {}
  }
}

export const SearchService = new SearchServiceClass();
